const getDataCY = (section: string, title: string) => `view-details-address-${section}-${title}`;

enum DataCy {
  CONTAINER = "container",
  HEADER = "header",
  TITLE = "title",
  TOGGLE = "toggle",
  CONTENT = "content",
  CONTENT_NAME = "content-name",
  CONTENT_ADDRESS1 = "content-address1",
  CONTENT_ADDRESS2 = "content-address2",
  CONTENT_STATE = "content-state",
  CONTENT_SUBURB = "content-suburb",
  CONTENT_COUNTRY = "content-country",
  CONTENT_POSTCODE = "content-postcode",
}

const upCaseFirstLetter = (value: string) =>
  value.substring(0, 1).toUpperCase() + value.substring(1);

export { upCaseFirstLetter };

export const Types = {
  DataCy,
  getDataCY,
};
